export default {
  DE: 'Deutschland',
  AT: 'Österreich',
  CH: 'Schweiz',
  FR: 'Frankreich',
  UK: 'Großbritannien',
  AF: 'Afghanistan',
  AX: 'Åland',
  AL: 'Albanien',
  DZ: 'Algerien',
  AS: 'Amerikanisch-Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarktis',
  AG: 'Antigua und Barbuda',
  AR: 'Argentinien',
  AM: 'Armenien',
  AW: 'Aruba',
  AU: 'Australien',
  AZ: 'Aserbaidschan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesch',
  BB: 'Barbados',
  BY: 'Weißrussland',
  BE: 'Belgien',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivien',
  BQ: 'Bonaire, Sint Eustatius und Saba',
  BA: 'Bosnien und Herzegowina',
  BW: 'Botswana',
  BV: 'Bouvetinsel',
  BR: 'Brasilien',
  IO: 'Britisches Territorium im Indischen Ozean',
  VG: 'Britische Jungferninseln',
  BN: 'Brunei',
  BG: 'Bulgarien',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Kambodscha',
  CM: 'Kamerun',
  CA: 'Kanada',
  CV: 'Kap Verde',
  KY: 'Kaimaninseln',
  CF: 'Zentralafrikanische Republik',
  TD: 'Tschad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Weihnachtsinsel',
  CC: 'Kokosinseln',
  CO: 'Kolumbien',
  KM: 'Komoren',
  CK: 'Cookinseln',
  CR: 'Costa Rica',
  HR: 'Kroatien',
  CU: 'Kuba',
  CW: 'Curacao',
  CY: 'Zypern',
  CZ: 'Tschechische Republik',
  CD: 'Demokratische Republik Kongo',
  DK: 'Dänemark',
  DJ: 'Dschibuti',
  DM: 'Dominica',
  DO: 'Dominikanische Republik',
  TL: 'Osttimor',
  EC: 'Ecuador',
  EG: 'Ägypten',
  SV: 'El Salvador',
  GQ: 'Äquatorialguinea',
  ER: 'Eritrea',
  EE: 'Estland',
  ET: 'Äthiopien',
  FK: 'Falkland-Inseln',
  FO: 'Färöer-Inseln',
  FJ: 'Fidschi',
  FI: 'Finnland',
  GF: 'Französisch-Guayana',
  PF: 'Französisch-Polynesien',
  TF: 'Französische Süd- und Antarktisgebiete',
  GA: 'Gabun',
  GM: 'Gambia',
  GE: 'Georgien',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Griechenland',
  GL: 'Grönland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard und McDonaldinseln',
  HN: 'Honduras',
  HK: 'Hongkong',
  HU: 'Ungarn',
  IS: 'Island',
  IN: 'Indien',
  ID: 'Indonesien',
  IR: 'Iran',
  IQ: 'Irak',
  IE: 'Irland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italien',
  CI: 'Elfenbeinküste',
  JM: 'Jamaika',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordanien',
  KZ: 'Kasachstan',
  KE: 'Kenia',
  KI: 'Kiribati',
  XK: 'Kosovo',
  KW: 'Kuwait',
  KG: 'Kirgisistan',
  LA: 'Laos',
  LV: 'Lettland',
  LB: 'Libanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libyen',
  LI: 'Liechtenstein',
  LT: 'Litauen',
  LU: 'Luxemburg',
  MO: 'Macao',
  MK: 'Mazedonien',
  MG: 'Madagaskar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Malediven',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshallinseln',
  MQ: 'Martinique',
  MR: 'Mauretanien',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexiko',
  FM: 'Mikronesien',
  MD: 'Moldawien',
  MC: 'Monaco',
  MN: 'Mongolei',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Marokko',
  MZ: 'Mosambik',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Niederlande',
  AN: 'Niederländische Antillen',
  NC: 'Neukaledonien',
  NZ: 'Neuseeland',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolkinsel',
  KP: 'Nordkorea',
  MP: 'Nördliche Marianen',
  NO: 'Norwegen',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palästinensische Autonomiegebiete',
  PA: 'Panama',
  PG: 'Papua-Neuguinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippinen',
  PN: 'Pitcairninseln',
  PL: 'Polen',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Katar',
  CG: 'Republik Kongo',
  RE: 'Réunion',
  RO: 'Rumänien',
  RU: 'Russland',
  RW: 'Ruanda',
  BL: 'Saint-Barthélemy',
  SH: 'St. Helena',
  KN: 'St. Kitts und Nevis',
  LC: 'St. Lucia',
  MF: 'St. Martin',
  PM: 'Saint-Pierre und Miquelon',
  VC: 'St. Vincent und die Grenadinen',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'São Tomé und Príncipe',
  SA: 'Saudi-Arabien',
  SN: 'Senegal',
  RS: 'Serbien',
  CS: 'Serbien und Montenegro',
  SC: 'Seychellen',
  SL: 'Sierra Leone',
  SG: 'Singapur',
  SX: 'Sint Maarten',
  SK: 'Slowakei',
  SI: 'Slowenien',
  SB: 'Salomon-Inseln',
  SO: 'Somalia',
  ZA: 'Südafrika',
  GS: 'Südgeorgien und die Südlichen Sandwichinseln',
  KR: 'Südkorea',
  SS: 'Südsudan',
  ES: 'Spanien',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard und Jan Mayen',
  SZ: 'Swasiland',
  SE: 'Schweden',
  SY: 'Syrien',
  TW: 'Taiwan',
  TJ: 'Tadschikistan',
  TZ: 'Tansania',
  TH: 'Thailand',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad und Tobago',
  TN: 'Tunesien',
  TR: 'Türkei',
  TM: 'Turkmenistan',
  TC: 'Turks- und Caicosinseln',
  TV: 'Tuvalu',
  VI: 'Amerikanische Jungferninseln',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'Vereinte Arabische Emirate',
  GB: 'Großbritannien',
  US: 'Vereinigte Staaten von Amerika (USA)',
  UM: 'United States Minor Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Usbekistan',
  VU: 'Vanuatu',
  VA: 'Vatikanstadt',
  VE: 'Venezuela',
  VN: 'Vietnam',
  WF: 'Wallis und Futuna',
  EH: 'Westsahara',
  YE: 'Jemen',
  ZM: 'Sambia',
  ZW: 'Simbabwe',
  EU: 'Europäische Union',
  WW: 'Weltweit',
  XB: 'Region Nordamerika',
  XC: 'Zentralamerikanische Region',
  XD: 'Region Südamerika',
  XE: 'Afrikanische Region',
  XF: 'Afrikanische Region südlich der Sahara',
  XG: 'Nordafrikanische Region',
  XH: 'Region Mittlerer Osten',
  XJ: 'Region Asien',
  XL: 'Pazifikraum',
  '097': 'Europäische Union',
  '001': 'Weltweit',
  '021': 'Region Nordamerika',
  '013': 'Zentralamerikanische Region',
  '005': 'Region Südamerika',
  '002': 'Afrikanische Region',
  202: 'Afrikanische Region südlich der Sahara',
  '015': 'Nordafrikanische Region',
  145: 'Region Mittlerer Osten',
  142: 'Region Asien',
  '009': 'Pazifikraum'
}



// WEBPACK FOOTER //
// ./src/i18n/de/countries.js